import React from 'react';

import { numberOfSlides } from '../../../constants';
import CardSkeleton from '../../Carousel/CardSkeleton';
import NewCarousel from '../../Carousel/NewCarousel';

interface DashboardRowShellProps {
	title: string;
	onShowAll?: () => void;
	loading: boolean;
	// Render nothing at all (no subjects, fetch error, or settled but too short).
	hidden: boolean;
	// The real cards; rendered only once loading has settled.
	children: React.ReactNode;
}

/**
 * Shared shell for the profile-aware dashboard rows: a `NewCarousel` that swaps
 * the title + cards for skeletons while loading, and hides the row entirely when
 * there is nothing worth showing. Callers own the data and the hide/cap policy.
 */
const DashboardRowShell: React.FC<DashboardRowShellProps> = ({
	title,
	onShowAll,
	loading,
	hidden,
	children,
}) => {
	if (hidden) return null;

	const skeletons = new Array(numberOfSlides.xl).fill(null);

	return (
		<NewCarousel title={title} onShowAll={onShowAll} loading={loading}>
			{/** biome-ignore lint/suspicious/noArrayIndexKey: index keys are pre-existing; switching the key source changes reconciliation behavior */}
			{loading ? skeletons.map((_, index) => <CardSkeleton key={index} />) : children}
		</NewCarousel>
	);
};

export default DashboardRowShell;
